module.exports = __webpack_public_path__ + "static/media/midas_s21.a0a87647.pdf";